import { apiClient } from '@/services/api'
import endpoints from '@/services/endpoints'

export default {
  // GET ACTIONS
  get: {
    all: async () => {
      try {
        const accounts = await apiClient.get(endpoints.account().all)
        return accounts
      } catch (error) {
        return error
      }
    },

    account: (id) => {
      return {
        self: apiClient.get(endpoints.account(id).self),
        users: apiClient.get(endpoints.account(id).users),
        cards: apiClient.get(endpoints.cards.accountCards(id)),
        cardTemplates: async () => {
          try {
            const templates = await apiClient.get(endpoints.account(id).cardTemplates)
            return templates
          } catch (error) {
            return error
          }
        },
      }
    },
  },

  // ADD ACTIONS (post)
  add: {
    card: async (accountId, cardId) => {
      const newCard = await apiClient.post(endpoints.account(accountId).addCard(cardId))
      return newCard
    },
  },
}
